import React from 'react'
import './Fiata.css'

function Fiata() {
    return (
        <div className="main-fiata-container">
            {/* Hero section with background image and overlay */}
            <div className="fiata-hero">
                <div className="fiata-overlay">
                    <h1>FIATA</h1>
                </div>
            </div>
            
            {/* White gap */}
            <div className="white-gap"></div>
            
            {/* Content section with FIATA information */}
            <div className="fiata-content">
                <h2>FIATA</h2>
                <p className="fiata-highlight">CENTREX Marine Services is a member of FIATA (International Federation of Freight Forwarders Associations).</p>
                
                <div className="fiata-section">
                    <h3>About FIATA</h3>
                    <p>FIATA, the International Federation of Freight Forwarders Associations, is a non-governmental, membership-based organization.</p>
                    <p>FIATA is a reference source on international policies and regulations governing the freight forwarding and logistics industry. FIATA works at the international level to represent service providers who operate in trade logistics and supply chain management.</p>
                </div>
                
                <div className="fiata-section">
                    <h3>Services & Commitment</h3>
                    <p>Through its FIATA documents and forms, digitalisation of key trade documents, annual congress and headquarters meeting, training and publications, it promotes trade facilitation and best practices among the freight forwarding community.</p>
                    <p>FIATA is committed to representing the interest of its members by actively engaging with the World Trade Organization, United Nations agencies and other international organizations, transport organizations, global partners and governments to promote and protect the interest of the industry.</p>
                </div>
                
                <div className="fiata-section">
                    <h3>History</h3>
                    <p>Founded in 1926 in Vienna, Austria, FIATA owes its acronym to its French name (Fédération Internationale des Associations de Transitaires et Assimilés) and is known as 'the global voice of freight logistics'. FIATA is headquartered in Geneva, Switzerland.</p>
                </div>
                
                <div className="fiata-link">
                    <a href="https://fiata.org/" target="_blank" rel="noopener noreferrer">
                        Visit FIATA Official Website
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Fiata
